// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?6119968868173a268f9e1ee40e41bd246e35620d";
};